import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-loading-spinner',
},
  __name: 'loading-spinner',
  props: {
  noMargin: {
    type: Boolean,
    required: false,
  },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sk-folding-cube", { margin: !__props.noMargin }])
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "sk-cube1 sk-cube" }, null, -1),
    _createElementVNode("div", { class: "sk-cube2 sk-cube" }, null, -1),
    _createElementVNode("div", { class: "sk-cube4 sk-cube" }, null, -1),
    _createElementVNode("div", { class: "sk-cube3 sk-cube" }, null, -1)
  ]))], 2))
}
}

})